import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class PageBuilderOptionsSelectors extends Component {
  // Services
  @service permission;

  // Template
  <template>
    <@form.fieldset
      @titleKey='selectors'
      @isClosed={{true}}
      @showSelectedAttributesIndicator={{true}}
      as |fieldset|
    >
      <fieldset.field @property='options.customContainerId' />
      <fieldset.field @property='options.customContainerClass' />

      {{yield}}
    </@form.fieldset>
  </template>
}
